<template>
  <div class="events-basic-information">
    <div class="row gap-3">
      <div class="col bg-2 p-4 rounded-16">
        <snow-input
          v-model="form.name"
          class="mb-6"
          label="Nome do evento *"
          :rules="rules.name"
        />
        <snow-input
          v-model="form.description"
          :rows="3"
          type="textarea"
          class="mb-6"
          label="Descrição *"
          :rules="rules.description"
        />
        <h5 class="text-semibold">Localização</h5>
        <div class="row mb-7 mt-4">
          <div class="col-lg-6 mb-6 mb-lg-0">
            <snow-input
              v-model="form.event_location"
              label="Local *"
              :rules="rules.event_location"
            />
          </div>
          <div class="col-lg-6">
            <snow-input
              v-model="form.event_address"
              label="Endereço do local *"
              :rules="rules.event_address"
            />
          </div>
        </div>
        <h5 class="text-semibold">Definir período do evento</h5>
        <div class="row mb-6 mt-2">
          <div class="col-lg-6 mb-lg-0">
            <snow-date-picker
              v-model="form.event_start_at"
              size="lg"
              format="YYYY-MM-DD HH:mm"
              isHours
            />
          </div>
          <div class="col-lg-6">
            <snow-date-picker
              v-model="form.event_end_at"
              format="YYYY-MM-DD HH:mm"
              size="lg"
              isHours
            />
          </div>
        </div>
        <action-dispatcher action="product/getCategories">
          <snow-select
            v-model="form.category_id"
            required
            label="Categoria do evento"
            :options="categories"
          />
        </action-dispatcher>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { maxLength, required } from "@/functions/validation";
import moment from "moment";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {
        name: [required(), maxLength(64)],
        description: [required(), maxLength(980)],
        event_location: [required()],
        event_address: [required()],
        event_start_at: [required()],
        event_end_at: [required()]
      }
    };
  },
  computed: {
    ...mapState("product", ["categories"])
  },
  mounted() {
    if (this.form.event_start_at) {
      this.form.event_start_at = moment(this.form.event_start_at).format("YYYY-MM-DD HH:mm");
    }

    if (this.form.event_end_at) {
      this.form.event_end_at = moment(this.form.event_end_at).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
